module.exports = __webpack_public_path__ + "media/dogs/dalmatian-red-656fe6a1.svg";